// src/lib/accountSwitchGrant.js — Browser copy of the signed account-switch
// grant ({ grant, expires_at }); see components/AccountSwitcher.js.
export const SWITCH_GRANT_KEY = 'rga-account-switch-grant'

export function readSwitchGrant() {
  try { return JSON.parse(localStorage.getItem(SWITCH_GRANT_KEY)) } catch { return null }
}

export function writeSwitchGrant(value) {
  try { localStorage.setItem(SWITCH_GRANT_KEY, JSON.stringify(value)) } catch {}
}

export function clearSwitchGrant() {
  try { localStorage.removeItem(SWITCH_GRANT_KEY) } catch {}
}
